// extracted by mini-css-extract-plugin
export var h1 = "component-module--h1--6e410";
export var h2 = "component-module--h2--71368";
export var h3 = "component-module--h3--0423b";
export var h4 = "component-module--h4--5f9c3";
export var h5 = "component-module--h5--4d67b";
export var lightColor = "component-module--lightColor--8ef88";